jPar.loginAndRegistration.registrationPage = jPar.loginAndRegistration.registrationPage || {};
deepMerge(true, jPar.loginAndRegistration.registrationPage, {
	socialSignOn: {
		init: function () {
			const hasAppleSocialButton = document.querySelector('peg-apple-social-button') !== null;
			const hasGoogleSocialButton = document.querySelector('peg-google-social-button') !== null;

			if (hasAppleSocialButton) {
				this.apple.init();
			}

			if (hasGoogleSocialButton) {
				this.google.init();
			}
		},

		google: {
			init: function () {
				this.error.showGoogleBackendErrorModal();
				this.error.showErrorNoEMailAdressModal();
				this.checkAutosubmit();
			},

			checkAutosubmit: function () {
				// /profile/registration/?scope=email&code=213214214&state=action%3Dreg%26oid%3D1%26search%3D10
				const isFromGoogle = jPar.util.getGetParamFromUrl('scope') !== undefined;
				const hasNoError = jPar.util.getGetParamFromUrl('error') === undefined;
				const hasCode = jPar.util.getGetParamFromUrl('code') !== undefined;

				if (isFromGoogle && hasNoError && hasCode) {
					const form = document.querySelector('#formRegistration');
					form.dataset.clickFromSocialLogin = 'true';
					this.addHiddenInputfields(form);
					form.submit();
				}
			},

			addHiddenInputfields: function (form) {
				const socialProviderInput = document.createElement('input');
				socialProviderInput.type = 'hidden';
				socialProviderInput.name = 'socialProvider';
				socialProviderInput.value = 'GOOGLE';

				const socialAccessTokenInput = document.createElement('input');
				socialAccessTokenInput.type = 'hidden';
				socialAccessTokenInput.name = 'socialAccessToken';
				socialAccessTokenInput.value = jPar.util.getGetParamFromUrl('code');

				form.appendChild(socialProviderInput);
				form.appendChild(socialAccessTokenInput);

				let state = jPar.util.getGetParamFromUrl('state');

				if (state) {
					state = decodeURIComponent(state);

					if (document.querySelector('#mysexEssexRow') === null) {
						const decodedStateValue = decodeURIComponent(state);
						const stateParams = new URLSearchParams(decodedStateValue);
						const gender = stateParams.get('search');
						const mysex = stateParams.get('mysex');
						const searchGenders = stateParams.get('searchGenders');

						const genderInput = document.createElement('input');
						genderInput.type = 'hidden';
						genderInput.name = 'gender';
						genderInput.value = gender;

						const mysexInput = document.createElement('input');
						genderInput.type = 'hidden';
						genderInput.name = 'mysex';
						genderInput.value = mysex;

						const searchGendersInput = document.createElement('input');
						searchGendersInput.type = 'hidden';
						searchGendersInput.name = 'searchGenders';
						searchGendersInput.value = searchGenders;

						form.appendChild(genderInput);
						form.appendChild(mysexInput);
						form.appendChild(searchGendersInput);
					}
				}
			},

			error: {
				showGoogleBackendErrorModal: function showGoogleBackendErrorModal() {
					if (document.querySelector('#googleBackendErrorModal') !== null) {
						jPar.wdk.modalbox.show({ modalboxId: 'googleBackendErrorModal' });
					}
				},

				showErrorNoEMailAdressModal: function () {
					if (document.querySelector('#googleNoEMailAdress') !== null) {
						jPar.wdk.modalbox.show({ modalboxId: 'googleNoEMailAdress' });
					}
				},
			},
		},

		apple: {
			init: function () {
				this.setEventlistener();
				this.error.showAppleBackendErrorModal();
				this.error.showErrorNoRegModal();
				this.checkAutosubmit();
			},

			setEventlistener: function () {
				let isValidform = false;

				document.querySelectorAll('#formRegistration input[type=radio], #formRegistration input[type=checkbox]').forEach(function (element) {
					element.addEventListener('click', function () {
						setTimeout(function () {
							isValidform = true;
							const mySex = document.querySelector('#mysexRow input:checked').value;
							const esSex = document.querySelector('#essexRow #hiddenEssex').value;
							document.querySelector('peg-apple-social-button').setAttribute('orientation', mySex + esSex);
						}, 50);
					});
				});

				document.querySelector('peg-apple-social-button').addEventListener('click', () => {
					if (isValidform === false) {
						event.preventDefault();
						jPar.loginAndRegistration.registrationPage.validate.validateSex({});
					} else {
						// lass den href klick einfach zu
					}
				});
			},

			checkAutosubmit: function () {
				// Return URL GET: /profile/registration?state=action%3Dreg%26oid%3D1%26search%3D10&code=c7c2135cecefa48d285d86a4a193347e3.0.sztx.WEf9EEabvDADxprdDr8HNQ&id_token=eyJraWQiOiJweWFSUXBBYm5ZIiwiYWxnIjoiUlMyNTYifQxxx&socialProvider=APPLE
				const isFromApple = jPar.util.getGetParamFromUrl('socialProvider') === 'APPLE';
				const hasNoError = jPar.util.getGetParamFromUrl('error') === undefined;

				if (isFromApple && hasNoError) {
					this.selectGenderInUi();
					const form = document.querySelector('#formRegistration');
					form.dataset.clickFromSocialLogin = 'true';
					this.localFormPreparation();
					form.submit();
				}
			},

			selectGenderInUi: function () {
				const url = window.location.href;
				const params = new URLSearchParams(url.split('?')[1]);
				const stateValue = params.get('state');
				const decodedStateValue = decodeURIComponent(stateValue);
				const stateParams = new URLSearchParams(decodedStateValue);
				const genderSearch = stateParams.get('search');

				if (genderSearch === '10') {
					document.querySelector('#mysexW').click();
					document.querySelector('#essexM').click();
				} else if (genderSearch === '01') {
					document.querySelector('#mysexM').click();
					document.querySelector('#essexW').click();
				} else if (genderSearch === '11') {
					document.querySelector('#mysexW').click();
					document.querySelector('#essexW').click();
				} else if (genderSearch === '00') {
					document.querySelector('#mysexM').click();
					document.querySelector('#essexM').click();
				}
			},

			localFormPreparation: function () {
				const appleButton = document.querySelector('peg-apple-social-button');
				const idToken =
					appleButton && appleButton.getAttribute('social-provider-token') !== null
						? appleButton.getAttribute('social-provider-token')
						: jPar.wdk.security.escapeStringForHtml(jPar.util.getGetParamFromUrl('id_token')); // <- deprecated by MOVE_TOKEN_PARAMETER_FROM_APPLE_LOGIN_BY_MANTIS - set empty string if appleButton.getAttribute('social-provider-token') = null
				const code = jPar.wdk.security.escapeStringForHtml(jPar.util.getGetParamFromUrl('code')); // Apple Information
				const user = jPar.util.getGetParamFromUrl('user'); // don't sanitize, because the param 'user' is a json, see: https://developer.apple.com/documentation/sign_in_with_apple/sign_in_with_apple_js/incorporating_sign_in_with_apple_into_other_platforms

				const template = document.createElement('template');
				const filledHiddenInputs = `
					<div>
						<input type="hidden" name="socialProvider" value="APPLE">
						<input type="hidden" name="id_token" value="${idToken}">
						<input type="hidden" name="code" value="${code}">
						<input type="hidden" name="user" value="${user}">
					</div>
				`;
				template.innerHTML = jPar.wdk.security.sanitizeEvilHtml(filledHiddenInputs);
				const node = template.content.firstElementChild;
				document.querySelector('#formRegistration').appendChild(node);
			},

			error: {
				showAppleBackendErrorModal: function showAppleBackendErrorModal() {
					if (document.querySelector('#appleBackendErrorModal') !== null) {
						jPar.wdk.modalbox.show({ modalboxId: 'appleBackendErrorModal' });
					}
				},

				showErrorNoRegModal: function () {
					if (document.querySelector('#appleNoReg') !== null) {
						jPar.wdk.modalbox.show({ modalboxId: 'appleNoReg' });
					}
				},
			},
		},
	},
});
